// ✅ Define e exporta a locale pt-BR para uso com AirDatepicker moderno
import ptBr from 'air-datepicker/locale/pt-BR';
// (Opcional) Exporta globalmente se quiser usar sem import
window.ptBR = ptBr;